import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { FormControl, InputAdornment, InputLabel, OutlinedInput, Popover } from '@mui/material';
import React, { cloneElement, isValidElement, useState } from 'react';

// Constants from AppShell
const BOTTOM_NAV_HEIGHT = 86;
const EXTRA_GUTTER = 12;
const TOTAL_BOTTOM_SPACE = BOTTOM_NAV_HEIGHT + EXTRA_GUTTER; // 98px

export default function SelectPopup({ 
  children, 
  label, 
  value, 
  onClosePopup, 
  inputStyle, 
  onOpenPopup, 
  size = 'medium', 
  ...otherProps 
}) {
  const [popperAnchor, setPopperAnchor] = useState(null);

  const handleClick = (event) => {
    setPopperAnchor(event.currentTarget);
    onOpenPopup?.();
  };

  const handleClose = () => {
    setPopperAnchor(null);
    onClosePopup?.();
  };

  return (
    <FormControl 
      {...otherProps} 
      focused={!!popperAnchor} 
      sx={inputStyle} 
      size={size}
    >
      <InputLabel>{label}</InputLabel>
      <OutlinedInput
        readOnly
        label={label}
        onClick={handleClick}
        value={value}
        sx={{ ...(size === 'small' && { paddingInlineEnd: '6px' }) }}
        endAdornment={
          <InputAdornment position="end">
            {!popperAnchor ? <ArrowDropDown /> : <ArrowDropUp />}
          </InputAdornment>
        }
      />
      <Popover
        open={!!popperAnchor}
        anchorEl={popperAnchor}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        // CRITICAL: Prevent popup from extending below viewport
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              // Constrain popup to stay above bottom nav bar
              maxHeight: {
                xs: `calc(100vh - ${TOTAL_BOTTOM_SPACE}px - env(safe-area-inset-bottom, 0px) - 100px)`,
                md: '85vh',
              },
              // Let the content handle its own scrolling
              overflow: 'visible',
              borderRadius: 2,
              boxShadow: 3,
            },
          },
        }}
        // Prevent scrolling issues on mobile
        disableScrollLock
      >
        {isValidElement(children)
          ? cloneElement(children, { onRequestClose: handleClose })
          : children}
      </Popover>
    </FormControl>
  );
}
